export default __webpack_public_path__ + "static/sandpit-7d5474ca4685ca985b3e3fd737610cee.jpg";